import axios from "../axios";
import { parseContentDispositionFilename } from "../../utils/http";

const api = {
  getCountries(accessToken) {
    const config = {
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.get("/countries", config).then(({ data }) => data);
  },


  /**
   * Call the server (with auth header), fetch data, and trigger a download-to-file.
   * TODO move into fileinfo.service
   * 
   * @param {object} params
   * @param {string} params.attachmentId Is this the FormKiq documentId??
   * @returns 
   */
  getAttachment({ attachmentId }) {
	// NB we need to send the auth header, hence this is an api call not just a link
    const config = {
      responseType: "arraybuffer",
    };
    return axios.get(`/attachments/${attachmentId}`, config)
      .then(({ data, headers }) => {
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement("a");
        const defaultFileName = parseContentDispositionFilename(headers["content-disposition"], "Attachment");
        link.href = url;
        link.setAttribute("download", defaultFileName);
        document.body.appendChild(link);
        link.click();
        return true;
      });
  },

  deleteAttachment({ attachmentId }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.delete(`/attachments/${attachmentId}`,
      headers).then(({ data }) => data);
  }
};

export default api;